import React from 'react';

import styles from './onboarding.module.css';
import { getLocale } from './locales';
import { useOnboarding } from './onboardingContext';

// Пульсирующая точка на кнопке, до которой новичок ещё не дошёл.
//
// Оборачивает кнопку: <Hotspot item="client"><Button /></Hotspot>. Как только
// соответствующий пункт чек-листа закрыт — точка пропадает навсегда, поэтому
// опытному менеджеру она на глаза не попадается.

const Hotspot = ({ item, hintKey, children }) => {
  const { checklistDone, checklistHidden } = useOnboarding();
  const locale = getLocale();

  // Без пункта чек-листа точке неоткуда узнать, что её пора гасить, — значит
  // она здесь не нужна вовсе.
  const show = item && !checklistHidden && !checklistDone.includes(item);
  if (!show) return children;

  const hint = hintKey ? locale.hotspots[hintKey] : null;

  return (
    <span className={styles.hotspot} title={hint || undefined}>
      {children}
      <span className={styles.dot} data-testid="onboarding-hotspot" />
    </span>
  );
};

export default Hotspot;
